import { render, staticRenderFns } from "./pharmacyPageDetail-06.vue?vue&type=template&id=2f7e8364&scoped=true"
import script from "./pharmacyPageDetail-06.vue?vue&type=script&lang=js"
export * from "./pharmacyPageDetail-06.vue?vue&type=script&lang=js"
import style0 from "./pharmacyPageDetail-06.vue?vue&type=style&index=0&id=2f7e8364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e8364",
  null
  
)

export default component.exports